import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { Breadcrumb } from 'antd';
import { navigate } from 'gatsby';

const Layout = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 0 24px;
  background-color: #fafbfc;
  margin-bottom: 30px;
  cursor: default;
  height: 100vh;
`;

const Content = styled.div`
  margin-top: 64px;
  display: flex;
  flex-direction: column;
  align-items: ${(props) => props.alignContent};
`;

const BreadcrumbsWrapper = styled.div`
  margin-top: 40px;
`;

function Default({ window, children, alignContent = 'center' }) {
  return (
    <Layout>
      {window && (
        <BreadcrumbsWrapper>
          <Breadcrumb>
            <Breadcrumb.Item
              href="#"
              onClick={() => navigate('/')}
            >
              Home
            </Breadcrumb.Item>
            <Breadcrumb.Item>{window}</Breadcrumb.Item>
          </Breadcrumb>
        </BreadcrumbsWrapper>
      )}
      <Content alignContent={alignContent}>{children}</Content>
    </Layout>
  );
}

Default.propTypes = {
  children: PropTypes.node.isRequired,
  alignContent: PropTypes.oneOf(['center', 'baseline']),
  window: PropTypes.string.isRequired,
};

Default.defaultProps = {
  alignContent: 'center',
};

export default Default;
